export default {
  titles: {
    all_orders: 'Alle Bestellungen',
    left_to_pay: 'Noch zu zahlen',
    no_orders: 'Alle Tischbestellungen werden hier aufgelistet',
  },
};